var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../../config/config';
import { getMapperForPlatform } from './mappers';
export class MockSearchProvider {
    constructor() {
        this.products = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [
            { id: 'relevance', label: 'Relevance' },
            { id: 'price:asc', label: 'Price: Low to High' },
            { id: 'price:desc', label: 'Price: High to Low' },
            { id: 'title:asc', label: 'Title: A to Z' },
            { id: 'title:desc', label: 'Title: Z to A' }
        ];
        this.baseUrl = `${AppConfig.mockServerUrl}/api/search`;
        this.mockPlatform = AppConfig.mockPlatform || 'algolia';
    }
    setMockPlatform(platform) {
        this.mockPlatform = platform;
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            var _a, _b;
            const { page = 1, pageSize = AppConfig.page.defaultSize, filters, sort = 'relevance' } = options;
            try {
                // Build query parameters
                const params = new URLSearchParams({
                    q: query,
                    _page: String(page),
                    _limit: String(pageSize),
                    platform: 'mock',
                    mockPlatform: this.mockPlatform
                });
                // Add sort parameter
                if (sort && sort !== 'relevance') {
                    params.append('sort', sort);
                }
                // Add filters
                if (filters) {
                    Object.entries(filters).forEach(([key, values]) => {
                        if (key === 'price' && values.length > 0) {
                            params.append('price', values[0]);
                        }
                        else {
                            values.forEach(value => {
                                params.append(key, value);
                            });
                        }
                    });
                }
                // Make the request
                const response = yield fetch(`${this.baseUrl}?${params.toString()}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const rawData = yield response.json();
                // Get the appropriate mapper for the mock platform
                const mapper = getMapperForPlatform(this.mockPlatform);
                // Check if this is a valid response for the platform
                if (!mapper.isValidResponse(rawData)) {
                    console.warn(`Invalid response format for platform: ${this.mockPlatform}`);
                    throw new Error('Invalid response format');
                }
                // Extract products based on platform format
                let rawProducts = [];
                console.log(`[MockSearchProvider] Platform: ${this.mockPlatform}, Raw data structure:`, Object.keys(rawData));
                if (rawData.hits) {
                    // Algolia format
                    console.log('[MockSearchProvider] Detected Algolia format');
                    rawProducts = rawData.hits;
                }
                else if ((_a = rawData.data) === null || _a === void 0 ? void 0 : _a.products) {
                    // Shopify format
                    console.log('[MockSearchProvider] Detected Shopify format');
                    rawProducts = rawData.data.products.edges.map((edge) => edge.node);
                }
                else if ((_b = rawData.response) === null || _b === void 0 ? void 0 : _b.products) {
                    // Unbxd format
                    console.log('[MockSearchProvider] Detected Unbxd format');
                    rawProducts = rawData.response.products;
                }
                else if (rawData.products) {
                    // Boost format
                    console.log('[MockSearchProvider] Detected Boost format');
                    rawProducts = rawData.products;
                }
                console.log(`[MockSearchProvider] Extracted ${rawProducts.length} products`);
                console.log('[MockSearchProvider] First product:', rawProducts[0]);
                // Use platform-specific mapper
                this.products = mapper.mapProducts(rawProducts);
                // Extract filters based on platform
                let filterData = null;
                if (this.mockPlatform === 'boost') {
                    filterData = rawData.filter;
                    console.log('[MockSearchProvider] Boost filter data:', filterData);
                }
                else {
                    filterData = rawData.facets || rawData.filters || [];
                }
                this.filters = mapper.mapFilters(filterData, filters);
                this.meta = mapper.mapMeta(rawData, page, pageSize);
            }
            catch (error) {
                console.error('Failed to fetch from mock API:', error);
                // Fallback to empty results
                this.products = [];
                this.filters = [];
                this.meta = {
                    totalResults: 0,
                    totalPages: 0,
                    currentPage: page,
                    pageSize: pageSize
                };
            }
        });
    }
    getProducts() {
        return this.products;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
}
